export default __webpack_public_path__ + "static/media/right2.a782669e.png";